module.exports = __webpack_public_path__ + "img/fr.7fd53294.svg";